import React, { useEffect, useState, useRef } from 'react'
import '../NewCollections/NewCollections.css'
import Item from '../Item/Item'
import placeholder from "../Assets/Frontend_Assets/placeholder.jpg";
import BASE_URL from '../../Config/api';
const NewCollections = () => {
  const [new_collection, setNew_collection] = useState([]);
  const sliderRef = useRef(null);

  useEffect(() => {
    fetch(`${BASE_URL}/newcollection`)
      .then((response) => response.json())
      .then((data) => setNew_collection(data));
  }, []);

   const slideNexts = () => {
    const slider = sliderRef.current;
    const cardWidth = slider.firstChild.offsetWidth + 20; // item width + gap
    slider.scrollBy({ left: cardWidth, behavior: "smooth" });
  };

  const slidePrevs = () => {
    const slider = sliderRef.current;
    const cardWidth = slider.firstChild.offsetWidth + 20;
    slider.scrollBy({ left: -cardWidth, behavior: "smooth" });
  };

  return (
    <div className='new-collections'>
      <h1>NEW COLLECTIONS</h1>
      <hr />

      <div className="slider-container">
        <button className="slider-btn left" onClick={slidePrevs}>
          &lt;
        </button>

        <div className="collections relatedproducts-item" ref={sliderRef}>
          {new_collection.map((item) => (
            <Item
                key={item.product_id}
                id={item.product_id}
                image={item.image || placeholder}
                product_name={item.product_name}
                productCode={item.product_code}
                pieces={item.pieces?.length ? `${item.pieces.length} Piece` : ""}
                clothType={item.cloth_type}
                brandname={item.brandname}
                type={item.type?.toUpperCase()}
                isNew={item.is_new}
                new_price={item.new_price}
                old_price={item.old_price}
              />
          ))}
        </div>

        <button className="slider-btn right" onClick={slideNexts}>
          &gt;
        </button>
      </div>
    </div>
  );
};

export default NewCollections;
